export default __webpack_public_path__ + "static/media/true.65959271.mp3";